import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Grid, Stack, Typography } from "@mui/material"
import { RiCloseFill } from 'react-icons/ri'
import { HiOutlineSearch } from "react-icons/hi";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
// import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import BlockContainer from "../../components/Container/BlockContainer"
import MainContainer from "../../components/Container/MainContainer"
import BaseIconInput from "../../components/BaseIconInput";
import BaseAccordion from "../../components/BaseAccordion";
import BaseLink from "../../components/BaseLink";
import BaseButton from "../../components/BaseButton";
import BaseImage from "../../components/BaseImage";
import { DEMO_FAQS } from "../../components/SectionFaq"
import BannerHowItWorks from '../../assets/images/library/banner-how-it-works.jpg'

const Faq = () => {
  const [searchKey, setSearchKey] = useState('')
  const [data, setData] = useState(DEMO_FAQS)
  const [showReminder, setShowReminder] = useState(false);
  const navigate = useNavigate();
  const [hasHistory, setHasHistory] = useState(false);

  useEffect(() => {
    if (window.history.state && window.history.state.idx > 0) {
        setHasHistory(true);
    }
  }, []);

  const handleClickSearch = (e) => {
    const value = e.target.value
    setSearchKey(value)
    setShowReminder(DEMO_FAQS.filter(item => item.question.toLowerCase().includes(value.toLowerCase()) || item.answer.toLowerCase().includes(value.toLowerCase())).length > 0)
    setData(DEMO_FAQS.filter(item => item.question.toLowerCase().includes(value.toLowerCase()) || item.answer.toLowerCase().includes(value.toLowerCase())))
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      // 👇 Get input value
      // handleClickSearch()
    }
  };

  const handleBack = () => {
      if (hasHistory) {
          navigate(-1);
      } else {
          navigate('/'); // Redirect to a default page
      }
  };

  return (
    <MainContainer
      sx={{
        padding: 0,
        bgcolor: 'background.default',
      }}
    >
      <BlockContainer>
        <Stack
          direction={'column'}
          sx={{
            borderRadius: '16px',
            padding: '24px 16px',
            boxShadow: '0px 2px 10px 0px #5B87EF1A',
            bgcolor: 'background.white',
            height: '100%'
          }}
          spacing={'32px'}
        >
          {/* <BaseLink
            to='/library'
            sx={{
              display: 'flex',
              alignItems: 'center'
            }}
          >
            <KeyboardBackspaceIcon 
              sx={{
                color: 'primary.darkGray',
                fontSize: '20px',
                mr: '5px'
              }}
            />
            <Typography variant="body" color='primary.darkGray'>
              Back to Library
            </Typography>
          </BaseLink> */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              cursor: 'pointer'
            }}
            onClick={handleBack}
          >
            <ArrowBackIcon
              sx={{
                color: 'primary.mediumGray',
                mr: '10px'
              }}
            />
            <Typography variant="body" color="primary.darkGray">
              Back
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="h1">
            Frequently Asked Questions
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end'
            }}
          >
            <Box sx={{
              width: '100%'
            }}>
              <BaseIconInput
                height='48'
                placeholder='Search'
                inputStyles={{
                  background: '#4266B833',
                  borderRadius: '40px',
                  color: '#46545F',
                  border: '#4266b800'
                }}
                sx={{
                  width: '100%'
                }}
                startIcon={<HiOutlineSearch size={20} />}
                endIcon={<RiCloseFill size={24} />}
                value={searchKey}
                onChange={handleClickSearch}
                onClickStartIcon={handleClickSearch}
                onClickEndIcon={() => {
                  setSearchKey('')
                  setShowReminder(false)
                  setData(DEMO_FAQS)
                }}
                onKeyDown={handleKeyDown}
              />
              {showReminder && (
                <Box sx={{ ml: '12px' }}>
                  <Typography variant="body" color='primary.red'>
                    Scroll down to see search results
                  </Typography>
                </Box>
              )}
            </Box>
          </Box>
          <Box>
            <Box
              sx={{
                height: { lg: '288px' },
                padding: '24px 16px',
                borderRadius: '16px',
                bgcolor: 'primary.lightGray',
                mb: '24px'
              }}
            >
              <Grid
                container
                spacing={'24px'}
                sx={{
                  flexDirection: { xs: 'column-reverse', md: 'row' }
                }}
              >
                <Grid
                  item xs={12} md={6}
                >
                  <Stack
                    direction={'column'}
                    spacing={'24px'}
                    sx={{
                      justifyContent: 'center',
                      height: '100%'
                    }}
                  >
                    <Typography variant="h2">
                      How does our analysis work?                    
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column'
                      }}
                    >
                      <Typography variant="body">
                        Read about how the genomic risk profiling works and which genes we examine.
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: { xs: 'column', md: 'flex' }
                      }}
                    >
                      <BaseLink
                        to="/how-it-works"
                        sx={{
                          mr: '8px'
                        }}
                      >
                        <BaseButton
                          buttonType={'primary'}
                          sx={{
                            maxWidth: '150px',
                            mb: { xs: '8px', md: '0' },
                            display: 'flex',
                            alignItems: 'center',
                          }}
                        >
                          <Typography variant="body">Read more</Typography>
                          <ChevronRightIcon 
                            sx={{
                              color: 'white',
                            }}
                          />
                        </BaseButton>
                      </BaseLink>
                      {/* <BaseLink to="/faq">
                        <BaseButton
                          buttonType={'default'}
                        >
                          <Typography variant="body">Frequently Asked Questions</Typography>
                        </BaseButton>
                      </BaseLink> */}
                    </Box>
                  </Stack>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: { xs: 'center', lg: 'flex-end' },
                      position: 'relative'
                    }}
                  >
                    <BaseImage
                      src={BannerHowItWorks}
                      sx={{
                        display: 'flex',
                        justifyContent: 'flex-end',
                        width: '472px',
                        maxHeight: '240px',
                      }}
                      sximage={{
                        borderRadius: '8px',
                        objectFit: 'cover'
                      }}
                    />
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        background: 'linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #000000 100%)',
                        width: '100%',
                        height: '240px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                        padding: '30px 24px',
                        borderRadius: '8px'
                      }}
                    >
                      <Typography
                        variant="h1"
                        sx={{
                          fontSize: '60px',
                          lineHeight: '90px',
                          textAlign: 'right',
                          color: 'white'
                        }}
                      >
                        HOW <br/>IT WORKS
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Stack container spacing={'24px'}>
              {data.map(((item, idx) => (
                <BaseAccordion
                  item={{
                    title: item.question,
                    description: item.answer
                  }}
                  sx={{
                    bgcolor: 'primary.lightGray'
                  }}
                  key={idx}
                />
              )))}
            </Stack>
          </Box>
        </Stack>
      </BlockContainer>
    </MainContainer>
  )
}

export default Faq